module.exports = __webpack_public_path__ + "media/npc_dota_hero_invoker.740b2277.webm";